export class HITLBase {
    static configure(request) {
        this.request = request;
        return this;
    }
    static format(template, values) {
        let result = template;
        for (const [key, value] of Object.entries(values)) {
            result = result.replace(new RegExp('\\{' + key + '\\}', 'gi'), value);
        }
        return result;
    }
    static getBaseUrl(options = {}) {
        const { version = this.LATEST_VERSION, module = this.MODULE_URL, } = options;
        const content = {
            version: version.toString(),
            module,
        };
        return this.format(this.BASE_URL, content);
    }
}
HITLBase.BASE_URL = '/api/v{version}/{module}';
HITLBase.LATEST_VERSION = 1;
HITLBase.MODULE_URL = '';
//# sourceMappingURL=HITLBase.js.map